if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        if (this.querySelector('.back-in-stock-form') != undefined) {
          this.renderBackInStock();
        }
      }

      renderBackInStock() {
        this.bisBtn = this.querySelector('.back-in-stock-form');
        this.bisBtnId = this.bisBtn?.dataset.modal;
        this.bisModalContent = document.querySelector(
          `${this.bisBtn.dataset.modal}`
        );

        if (this.bisModalContent == undefined || this.bisModalContent == null) {
          return;
        }

        this.bisSubmitBtn =
          this.bisModalContent.querySelector('.bis-submit-btn');
        this.bisEmailInput = this.bisModalContent.querySelector('.bis-email');
        this.bisSuccessMsg =
          this.bisModalContent?.querySelector(
            '.bis-success-msg'
          ).dataset.bisSuccessMsg;
        this.bisMessage = this.bisModalContent.querySelector('.bis-message');

        this.bisSubmitBtn?.addEventListener('click', () => {
          let productId = parseInt(this.bisSubmitBtn.dataset.productId);
          let variantId = parseInt(this.bisSubmitBtn.dataset.variantId);
          let email = this.bisSubmitBtn.dataset.emailInput;
          let bisListId = this.bisSubmitBtn.dataset.bisListId;
          let apiKey = this.bisSubmitBtn.dataset.apiKey;
          let data = {
            a: apiKey,
            email: email,
            platform: 'shopify',
            variant: variantId,
            product: productId,
            list: bisListId,
          };
          this.subscribeToNotification(data);
        });

        this.bisEmailInput?.addEventListener('change', () => {
          this.emailCheck();
        });

        this.bisEmailInput?.addEventListener('keyup', () => {
          this.emailCheck();
        });
      }

      emailCheck() {
        this.bisSubmitBtn.dataset.emailInput = this.bisEmailInput.value;
        if (!this.bisSubmitBtn.dataset.emailInput.includes('@')) {
          this.bisSubmitBtn.setAttribute('disabled', true);
        } else {
          this.bisSubmitBtn.removeAttribute('disabled');
        }
      }

      subscribeToNotification(data) {
        fetch(
          'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
          {
            headers: {
              accept: 'application/json, text/plain, */*',
              'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: new URLSearchParams(data),
            method: 'POST',
          }
        )
          .then((response) => {
            this.bisMessage.innerHTML = `
              <h6>${this.bisSuccessMsg}</h6>
            `;
          })
          .catch((err) => {
            console.error(err);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.addItem();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      }

      addItem() {
        this.handleErrorMessage();

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading-overlay__spinner')) {
          this.querySelector('.loading-overlay__spinner').classList.remove(
            'hidden'
          );
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          let sections = this.cart
            .getSectionsToRender()
            .map((section) => section.id);
          if (this.cartItems) {
            sections = [
              ...new Set(
                sections.concat(
                  this.cartItems
                    .getSectionsToRender()
                    .map((section) => section.section)
                )
              ),
            ];
          }
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let cartDrawerItems = document.querySelector('cart-drawer-items');
        let freeSubscriptionVariantAlreadyInCart =
          cartDrawerItems?.dataset.cartFreeSubscriptionItems?.includes(
            formData.get('id')
          );

        if (freeSubscriptionVariantAlreadyInCart) {
          let subscriptionPrice = parseInt(formData.get('subscription_price'));
          let sellingPlan = formData.get('selling_plan');

          if (sellingPlan != null && subscriptionPrice == 0) {
            formData.delete('selling_plan');
          }
        }

        config.body = formData;

        // script for handling adding free product to cart

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton?.setAttribute('aria-disabled', true);
              this.submitButton?.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.checkVariantUpsell(this.form, this.cart, response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.checkVariantUpsell(this.form, this.cart, response);
            }

            const event = new CustomEvent('cart:add', {
              detail: {
                cartData: response,
                productForm: this.form,
              }
            });

            document.dispatchEvent(event);
            this.getCartContents()
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading-overlay__spinner')) {   
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden'
              );
            }
          });
      }

      // giftScript() {
      //   const giftCombinations = window.gift_campaigns.combinations;
      //   const selectedVariantId = parseInt(
      //     this.form?.querySelector('[name=id]')?.value
      //   );
      //   let isEventProduct = giftCombinations.find((combination) =>
      //     combination?.eligible_variants.includes(selectedVariantId)
      //   );
      //   let secondaryCombinations = giftCombinations.filter(
      //     (combination) => combination?.gift_is_secondary == true
      //   );
      //   let secondaryVariantIds = [];
      //   secondaryCombinations.map((combination) => {
      //     secondaryVariantIds.push(combination?.gift_variant_id);
      //   });
      //   let isEventProductSecondary = secondaryVariantIds.includes(
      //     isEventProduct?.gift_variant_id
      //   );
      //   let giftVariantId = isEventProduct?.gift_variant_id; // free item for selected product
      //   // all free items from the combinations
      //   let giftVariantIds = giftCombinations.map(
      //     (combination) => combination.gift_variant_id
      //   );

      //   let cartContents = document.getElementById('CartDrawerContent')
      //     ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      //     : undefined;
      //   let cartHasFreeItem = this.isFreeGiftInCart(
      //     cartContents.items,
      //     giftVariantIds
      //   );
      //   let secondaryFreeProductInCart = secondaryCombinations.find(
      //     (combination) =>
      //       this.isFreeGiftInCart(cartContents.items, [
      //         combination.gift_variant_id,
      //       ])
      //   );

      //   // if cart does not have the free product, add it
      //   if (!cartHasFreeItem && isEventProduct) {
      //     this.handleGiftProduct(this.cart, giftVariantId, false);
      //   }

      //   // if cart has a free product, but it is a secondary free product, and the new free product is a primary free product, remove the secondary free product and add the new primary free product
      //   if (
      //     cartHasFreeItem &&
      //     secondaryFreeProductInCart &&
      //     isEventProduct &&
      //     !isEventProductSecondary
      //   ) {
      //     this.handleGiftProduct(
      //       this.cart,
      //       giftVariantId,
      //       secondaryFreeProductInCart.gift_variant_id
      //     );
      //   }
      // }
      async getCartContents() {
        let cartContents;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          const data = await response.json();
          cartContents = data;
          const event = new CustomEvent('cart:update', {
            detail: { cartState: cartContents },
          });
          document.dispatchEvent(event);
        } catch (error) {
          console.log(error);
        }
        return cartContents;
      }

      // isFreeGiftInCart(cartItems, giftVariantIdsArr) {
      //   let cartItemsArr = cartItems.map((item) => item.id);
      //   // check cart items against free gift variant ids
      //   for (let ii = 0; ii < cartItemsArr.length; ii++) {
      //     for (let jj = 0; jj < giftVariantIdsArr.length; jj++) {
      //       if (cartItemsArr[ii] == giftVariantIdsArr[jj]) {
      //         return true;
      //       }
      //     }
      //   }
      //   return false;
      // }

      // handleGiftProduct(cart, giftVariantIdToAdd, giftVariantIdToRemove) {
      //   let data = {
      //     sections: 'cart-drawer,cart-icon-bubble',
      //     updates: {},
      //   };

      //   let cartContents = document.getElementById('CartDrawerContent')
      //     ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      //     : undefined;
      
      //   if (giftVariantIdToAdd && ((!window.gift_campaigns.min_order_value) || (window.gift_campaigns.min_order_value && window.gift_campaigns.min_order_value <= cartContents.total_price))) {
      //     data.updates[giftVariantIdToAdd] = 1;
      //   }

      //   if (giftVariantIdToRemove && ((!window.gift_campaigns.min_order_value) || (window.gift_campaigns.min_order_value && window.gift_campaigns.min_order_value > cartContents.total_price))) {
      //     data.updates[giftVariantIdToRemove] = 0;
      //   }

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   config.body = JSON.stringify(data);
      //   config.method = 'POST';
      //   fetch(`${routes.cart_update_url}`, config)
      //     .then((res) => res.json())
      //     .then((res) => cart.renderContents(res))
      //     .catch((e) => {
      //       console.error(e);
      //     });
      // }

      checkVariantUpsell(form, cart, response) {
        if (
          form.querySelector('[name=id]').dataset.upsellOtherVariants ==
            'true' &&
          form.querySelector('[name=id]').dataset.otherVariantsAvailable ==
            'true' &&
          sessionStorage.getItem('upsell') == null
        ) {
          this.runVariantsUpsell(response);
        } else {
          if (
            form.dataset.variantUpsell == 'true' &&
            sessionStorage.itemQty != null &&
            sessionStorage.itemToRemove != null
          ) {
            let data = {
              id: sessionStorage.itemToRemove,
              quantity: parseInt(sessionStorage.itemQty) - 1,
              sections: 'cart-drawer,cart-icon-bubble',
            };
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify(data);
            config.method = 'POST';
            fetch(`${routes.cart_change_url}`, config)
              .then((res) => res.json())
              .then((res) => {
                if (res.status) {
                  alert(res.description);
                  return;
                }
                cart.renderContents(res);
                sessionStorage.setItem('upsellResponse', 'true');
              })
              .catch((e) => {
                console.error(e);
              });
          } else {
            if (this.cartItems) {
              this.cartItems.renderContents(response);
            }
            this.cart.renderContents(response);
          }
        }
      }

      runVariantsUpsell(response) {
        sessionStorage.setItem('upsell', 'true');
        sessionStorage.setItem('itemToRemove', `${response.key}`);
        sessionStorage.setItem('itemQty', `${response.quantity}`);
        const upsellVariantPopup = document.getElementById(
          'PopupModal-upsell-variants'
        );
        const upsellPopupContent = upsellVariantPopup.querySelector(
          '.product-popup-modal__content'
        );
        upsellVariantPopup.setAttribute('open', '');
        const refuseBtns =
          upsellVariantPopup.querySelectorAll('.refuse-button');

        // if declined, view cart content on click of refuse buttons
        refuseBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.cart.renderContents(response);
            sessionStorage.setItem('upsellResponse', 'true');
          });
        });

        // if click outside of upsell popup, view cart immediately
        document.addEventListener('click', (e) => {
          if (
            !upsellPopupContent.contains(e.target) &&
            sessionStorage.getItem('upsellResponse') == null
          ) {
            this.cart.renderContents(response);
            sessionStorage.setItem('upsellResponse', 'true');
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  let variantRadiosInputs = document.querySelectorAll('variant-radios');
   variantRadiosInputs?.forEach((radio) => radio.classList.remove('is-loading'))
});
